<template>
  <div id="app" :class="[classes]">
    <partial-header />

    <main v-if="this.config">
      <transition name="fade" appear>
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main>

    <partial-footer />
  </div>
</template>

<script>
import Config from '@/models/config'
import PartialHeader from '@partials/top'
import PartialFooter from '@partials/bottom'

export default {
  components: { PartialHeader, PartialFooter },
  provide () {
    const provide = {}

    Object.defineProperty(provide, '$config', {
      enumerable: true,
      get: () => this.config
    })

    return provide
  },
  data: () => ({
    config: null
  }),
  async beforeCreate () {
    this.config = await Config.get()
  },
  computed: {
    classes () {
      let collection = [
        `${this.$route.name}`.toLowerCase() + '-view',
        'view'
      ]

      if (this.$route.name !== 'Home') {
        collection.push('toggledNavigation')
      }

      if (this.$store.state.showMainNavigation) {
        collection.push('main-navigtaion-shown')
      }

      return collection
    }
  }
}
</script>

<style lang="scss">
  @import '~@resets/reset';

  /* Import from Spar Nord Assets */
  @import '~@styles/global/index';
  @import '~@styles/colors/variables';
  @import '~@styles/mq/variables';
  @import '~@styles/mixins/index';
  @import '~@animations/easings/variables';
  @import '~@animations/durations/variables';

    @import '~@helpers/button';

  body,
  html {
    min-height: 100%;
    width: 100vw;

    margin: 0;
    padding: 0;

    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: geometricPrecision;
    text-rendering: optimizeLegibility;

    background-color: $color-white;
  }

  html {
    box-sizing: border-box;
  }

  body {
    position: relative;

    font-family: $font-family;
    font-size: 100%;
    line-height: 1;
    font-weight: 400;
    color: $color-black;

    overflow-x: hidden;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  img {
    width: 100%;
    height: auto;
    outline: none;
  }

  #app {
    position: relative;
    height: 100%;
    min-height: 100vh;

    transition: transform $duration-normal $easeing-OutExpo;
  }

  /* wrap elements in a container */
  .wrap {
    @include container($global-width, 100%, $global-padding);
  }

  /* main */
  main {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;

    justify-content: flex-start;

    position: relative;

    max-width: 100vw;
    overflow: hidden;
  }

  /* Enter and leave animations for route changes */
  .fade-enter-active, .fade-leave-active {
    transition: all $duration-normal / 1.8 ease;
  }

  .fade-enter-active {
    transition-duration: $duration-normal / 1.8;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(5px);
  }

  /* SPLIT ME */
  section {
    margin-bottom: 80px;

    @media #{$above-breakpoint-768} {
      margin-bottom: 160px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue